module.exports = __webpack_public_path__ + "img/66.79a22691.jpg";